import {Navigate, Route, Routes} from 'react-router-dom'
import {ManagementLayout} from '../pages/Management/ManagementLayout'
import {ManagementDashboard} from '../pages/Management/ManagementDashboard'
import UserManagement from '../pages/Management/UserManagement'
import StepStepMotor from '../pages/Management/StepStepMotor'
import Device from '../pages/Management/Device'
import DeviceGroups from '../pages/Management/DeviceGroups'
import DeviceTypes from '../pages/Management/DeviceTypes'
import SelectedDevice from '../pages/Management/SelectedDevice'
import SelectedDeviceGroup from '../pages/Management/SelectedDeviceGroup'
import SelectedDeviceType from '../pages/Management/SelectedDeviceType'
import Experiment from '../pages/Management/Experiment'
import SelectedExperiment from '../pages/Management/SelectedExperiment'
import SelectedCircuit from '../pages/Management/SelectedCircuit'
import Category from '../pages/Management/Category'
import SMRTopic from '../pages/Management/SMRTopic'
import Unit from '../pages/Management/Unit'
import Content from '../pages/Management/Content'
import SelectedContent from '../pages/Management/SelectedContent'
import SelectedUser from '../pages/Management/SelectedUser'
import ReferencesCode from '../pages/Management/ReferencesCode'
import Codap from '../pages/Management/Codap'
import DeviceRoutes from './DeviceRoutes'
import DeviceGroupRoutes from './DeviceGroupRoutes'
import DeviceTypeRoutes from './DeviceTypeRoutes'
import ContentRoutes from './ContentRoutes'
import ExperimentRoutes from './ExperimentRoutes'

function ManagementRoutes() {
  return (
    <Routes>
      <Route element={<ManagementLayout />}>
        <Route path='/' element={<Navigate to='/management/dashboard' />} />
        <Route path='dashboard' element={<ManagementDashboard />} />
        {/* User */}
        <Route path='users' element={<UserManagement />} />
        <Route path='users/selected-user' element={<SelectedUser />} />
        <Route path='references-code' element={<ReferencesCode />} />
        {/* Device */}
        <Route path='all-device/device' element={<Device />} />
        <Route path='all-device/device/*' element={<DeviceRoutes />} />
        {/*}
        <Route path='all-device/device/selected-device' element={<SelectedDevice />} />
  {*/}
        <Route path='all-device/device-groups' element={<DeviceGroups />} />
        <Route path='all-device/device-groups/*' element={<DeviceGroupRoutes />} />
        {/*}
        <Route
          path='all-device/device-groups/selected-device-group'
          element={<SelectedDeviceGroup />}
        />
{*/}
        <Route path='all-device/device-types' element={<DeviceTypes />} />
        <Route path='all-device/device-types/*' element={<DeviceTypeRoutes />} />
        {/*}
        <Route
          path='all-device/device-types/selected-device-type'
          element={<SelectedDeviceType />}
        />
{*/}
        {/* Experiment */}
        <Route path='experiment' element={<Experiment />} />
        <Route path='experiment/*' element={<ExperimentRoutes />} />
        {/*}
        <Route path='experiment/selected-experiment' element={<SelectedExperiment />} />

        <Route
          path='experiment/selected-experiment/selected-circuit'
          element={<SelectedCircuit />}
        />
        */}
        {/* Category */}
        <Route path='category' element={<Category />} />
        {/* Content */}
        <Route path='content' element={<Content />} />
        <Route path='content/*' element={<ContentRoutes />} />
        {/*}
        <Route path='content/selected-content' element={<SelectedContent />} />
{*/}
        {/* Unit */}
        <Route path='unit' element={<Unit />} />
        {/* SMR Topic */}
        <Route path='smr-topic' element={<SMRTopic />} />
        <Route path='setup-stepmotor' element={<StepStepMotor />} />
        <Route path='codap' element={<Codap />} />
      </Route>
    </Routes>
  )
}

export default ManagementRoutes
